// @kiao-voice/hooks — shared React logic hooks for desktop + web.
//
// Lives separately from @kiao-voice/core (which the backend imports) so React
// never leaks into the server's dependency graph. UI components belong in
// @kiao-voice/ui-kit; this package is for cross-app logic hooks only.
export { useActiveContext } from './use-active-context'
export {
  useWorkspaceScopedLoader,
  type UseWorkspaceScopedLoaderOptions,
  type WorkspaceScopedLoadContext,
} from './use-workspace-scoped-loader'
export {
  useVoiceQuota,
  VOICE_QUOTA_REFRESH_STALE_MS,
  VOICE_QUOTA_UNLIMITED_REFRESH_STALE_MS,
  type VoiceQuotaState,
  type UseVoiceQuotaOptions,
} from './use-voice-quota'
export {
  useOrganizationIdentity,
  type OrganizationIdentity,
  type UseOrganizationIdentityArgs,
} from './use-organization-identity'
export {
  useDismissablePopover,
  type UseDismissablePopoverOptions,
  type UseDismissablePopoverResult,
} from './use-dismissable-popover'
export { useReferral, type ReferralState, type UseReferralOptions } from './use-referral'
